import { render, staticRenderFns } from "./onlineEdit.vue?vue&type=template&id=0ff748d0&scoped=true&"
import script from "./onlineEdit.vue?vue&type=script&lang=ts&"
export * from "./onlineEdit.vue?vue&type=script&lang=ts&"
import style0 from "./onlineEdit.vue?vue&type=style&index=0&id=0ff748d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff748d0",
  null
  
)

export default component.exports